import Page from "../../../../material/skeleton/Page";
import Header from "../../../../material/skeleton/Header";
import Menu from "./Menu";
import {useParams} from "react-router";
import useInterventionRepository from "../../../../repository/emergency/useInterventionRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {Backdrop, Button, Chip, CircularProgress} from "@mui/material";
import useAxiosConfigHeader from "../../../../use/useAxiosConfigHeader";
import useQualityInspectionRepository from "../../../../repository/emergency/useQualityInspectionRepository";
import Modal from "../../../../material/modal/Modal";
import ModalConfig from "../../../../material/modal/ModalConfig";
import Create from "./message/Create";
import StepWrapper from "./StepWrapper";
import useClientRepository from "../../../../repository/emergency/useClientRepository";
import {Help, Start} from "@mui/icons-material";
import Intervention from "../../../../entity/emergency/Intervention";
import Body from "../../../../material/skeleton/Body";
import Typography from "@mui/material/Typography";
import useEmergencyInterventionDemoSound from "./demo/useEmergencyInterventionDemoSound";
import LockInteract from "./demo/LockInteract";
import OrderData from "./OrderData";
import useOrderRepository from "../../../../repository/emergency/useOrderRepository";
import ClientPriceCertificate from "./requested-document/client-price-certificate/ClientPriceCertificate";

export default function () {
    const {token} = useParams();
    const {start} = useEmergencyInterventionDemoSound();
    const headerConfigured = useAxiosConfigHeader("emergency", token);
    const orderRepository = useOrderRepository();
    const interventionRepository = useInterventionRepository();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const clientRepository = useClientRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneByToken(token).select();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(intervention?.getQualityInspectionId()).select();
    /** @type Client */
    const client = clientRepository.findOneByOrderId(intervention?.getOrderId()).select();
    const [openCreateMessage, setOpenCreateMessage] = useState(false);
    const [openOrderData, setOpenOrderData] = useState(false);
    const [updateQuotation, setUpdateQuotation] = useState(false);
    const [openClientPriceCertificate, setOpenClientPriceCertificate] = useState(false);
    const [startDemo, setStartDemo] = useState(false);

    useEffect(() => {
        if (!headerConfigured) return;

        interventionRepository.findOneByToken(token).exec();
    }, [headerConfigured]);

    useEffect(() => {
        if (isNull(intervention)) return;

        qualityInspectionRepository.findOneById(intervention?.getQualityInspectionId()).exec();
        clientRepository.findOneByOrderId(intervention?.getOrderId()).exec();
        orderRepository.findOneById(intervention.getOrderId()).exec(false);
    }, [JSON.stringify(intervention)]);

    const toggleOpenCreateMessage = o => () => setOpenCreateMessage(o);
    const toggleOpenOrderData = o => () => setOpenOrderData(o);
    const toggleUpdateQuotation = o => () => setUpdateQuotation(o);
    const toggleOnOpenClientPriceCertificate = o => () => setOpenClientPriceCertificate(o);

    const handleStartDemo = () => {
        setStartDemo(true);
        start();
    }

    const handleHelp = () => start();

    if (isNull(qualityInspection) || isNull(client) || isNull(intervention) || !headerConfigured) {
        return (
            <Box display="flex" justifyContent="center" mt={20}>
                <CircularProgress/>
            </Box>
        );
    }

    if (intervention.getStatus() === Intervention.STATUS_FAILED) {
        return (
            <Page>
                <Header>
                    <Menu
                        orderId={intervention.getOrderId()}
                        qualityInspectionId={intervention.getQualityInspectionId()}
                        clientId={client.getId()}
                        onLetMessageClicked={toggleOpenCreateMessage(true)}
                        onOpenOrderData={() => {
                        }}
                    />
                </Header>
                <Body>
                    <Box mt={20}>
                        <Typography variant="h6" textAlign={"center"}>
                            L'intervention est annulée
                        </Typography>
                    </Box>
                </Body>
            </Page>
        )
    }

    return (
        <Page>
            {
                token === "demo" && !startDemo
                    ? (
                        <Backdrop
                            sx={(theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
                            open={true}
                        >
                            <Button variant="contained" startIcon={<Start/>} color="warning" onClick={handleStartDemo}>
                                Démarrer la formation
                            </Button>
                        </Backdrop>
                    )
                    : null
            }
            <Header>
                <Menu
                    orderId={intervention.getOrderId()}
                    qualityInspectionId={intervention.getQualityInspectionId()}
                    onLetMessageClicked={toggleOpenCreateMessage(true)}
                    clientId={client.getId()}
                    onUpdateQuotation={toggleUpdateQuotation(true)}
                    onOpenOrderData={toggleOpenOrderData(true)}
                    onOpenClientPriceCertificate={toggleOnOpenClientPriceCertificate(true)}
                    updateQuotation={updateQuotation}
                />
            </Header>
            <StepWrapper
                qualityInspectionId={qualityInspection.getId()}
                clientId={client.getId()}
                interventionId={intervention.getId()}
                orderId={intervention.getOrderId()}
                updateQuotation={updateQuotation}
                onQuotationUpdated={toggleUpdateQuotation(false)}
            />

            <Box position="fixed" bottom={60} right={10} onClick={handleHelp}>
                <Chip icon={<Help/>} label={"Assistant"} color={"warning"}/>
            </Box>
            {
                openCreateMessage
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("60%")
                                    .setOnClose(toggleOpenCreateMessage(false))
                                    .setComponent(
                                        <Create
                                            interventionId={intervention.getId()}
                                            onSuccess={toggleOpenCreateMessage(false)}
                                        />
                                    )
                            }
                        />
                    )
                    : null
            }

            {
                openOrderData
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("100%")
                                    .setOnClose(toggleOpenOrderData(false))
                                    .setComponent(<OrderData orderId={intervention.getOrderId()}/>)
                            }
                        />
                    )
                    : null
            }

            {
                openClientPriceCertificate
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("100%")
                                    .setOnClose(toggleOnOpenClientPriceCertificate(false))
                                    .setComponent(<ClientPriceCertificate interventionId={intervention.getId()}/>)
                            }
                        />
                    )
                    : null
            }

            <LockInteract/>
        </Page>
    )
}